import { render, staticRenderFns } from "./ContributorsModal.vue?vue&type=template&id=79ff73f2"
import script from "./ContributorsModal.vue?vue&type=script&lang=js"
export * from "./ContributorsModal.vue?vue&type=script&lang=js"
import style0 from "./ContributorsModal.vue?vue&type=style&index=0&id=79ff73f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports